"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHighlight = void 0;
const react_1 = __importStar(require("react"));
const event_callback_hook_1 = require("../../../../utils/event-callback-hook");
const VALUE_COLOR = '#c2eafc';
const KEYWORD_COLOR = '#fffacf';
function useHighlight(props) {
    const { text, inputScrollOffset, inputWidth } = props;
    /**
     * Highlights are implemented as a copy of values with transparent color and colorfull background.
     *
     * `highlightRef` stores reference to div in which is this transparent copy.
     */
    const highlightRef = (0, react_1.useRef)(null);
    /**
     * Highlighted positions: #fffacf = keyword, #c2eafc = value
     */
    const [highlights, setHighlights] = (0, react_1.useState)([]);
    /**
     * Handler function, evaluated after filterbox value is changed.
     */
    const handleHighlight = (0, event_callback_hook_1.useEventCallback)((event) => {
        if (event.type === 'rule.match' &&
            (event.rule === 'Field' || event.rule === 'Value') &&
            'result' in event) {
            setHighlights((highlights) => [
                ...highlights,
                {
                    start: event.location.start.offset,
                    end: event.location.start.offset + event.result.length,
                    type: event.rule.toLowerCase(),
                },
            ]);
        }
    });
    (0, react_1.useEffect)(() => {
        if (highlightRef.current) {
            highlightRef.current.scrollLeft = inputScrollOffset;
        }
    });
    const highlightedText = (0, react_1.useMemo)(() => {
        let highlightedText = text;
        highlights.forEach((highlight, i) => {
            const offset = i * 67;
            let trimmed = '';
            let whiteSpacesCount = 0;
            let textBefore = highlightedText.substring(0, highlight.start + offset);
            const replaced = highlightedText.substring(highlight.start + offset, highlight.end + offset);
            trimmed = replaced.trimStart();
            whiteSpacesCount = replaced.length - trimmed.length;
            textBefore = textBefore.padEnd(whiteSpacesCount + textBefore.length);
            let textAfter = highlightedText.substring(highlight.end + offset, highlightedText.length);
            trimmed = replaced.trimEnd();
            whiteSpacesCount = replaced.length - trimmed.length;
            textAfter = textAfter.padStart(whiteSpacesCount + textAfter.length);
            highlightedText =
                textBefore +
                    `<mark style="background-color: ${highlight.type === 'value' ? VALUE_COLOR : KEYWORD_COLOR}; color: transparent">` +
                    replaced.trim() +
                    '</mark>' +
                    textAfter;
        });
        return (react_1.default.createElement("div", { style: {
                position: 'absolute',
                width: inputWidth !== null && inputWidth !== void 0 ? inputWidth : 'auto',
            } },
            react_1.default.createElement("div", { ref: highlightRef, style: {
                    color: 'transparent',
                    whiteSpace: 'pre',
                    overflow: 'hidden',
                }, dangerouslySetInnerHTML: { __html: highlightedText } })));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [highlights, text, inputWidth]);
    return {
        highlightedText,
        setHighlights,
        handleHighlight,
    };
}
exports.useHighlight = useHighlight;
//# sourceMappingURL=highlight-hook.js.map